"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoToPreviousHeaderFooterCommand = exports.GoToNextHeaderFooterCommand = exports.GoToNextPrevHeaderFooterCommandBase = void 0;
var tslib_1 = require("tslib");
var client_command_1 = require("../client-command");
var change_active_sub_document_command_1 = require("../sub-document/change-active-sub-document-command");
var header_footer_command_base_1 = require("./header-footer-command-base");
var GoToNextPrevHeaderFooterCommandBase = (function (_super) {
    tslib_1.__extends(GoToNextPrevHeaderFooterCommandBase, _super);
    function GoToNextPrevHeaderFooterCommandBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoToNextPrevHeaderFooterCommandBase.prototype.executeCore = function (_state, _options) {
        var selection = this.selection;
        var pageIndex = this.moveFunction(selection.pageIndex);
        var activeSubDocument = this.selection.activeSubDocument;
        var isHeader = activeSubDocument.isHeader();
        for (var layoutPage = void 0; layoutPage = this.control.layoutFormatterManager.forceFormatPage(pageIndex); pageIndex = this.moveFunction(pageIndex)) {
            var pageArea = isHeader ?
                layoutPage.getLayoutOtherPageAreasInfo().headerPageArea :
                layoutPage.getLayoutOtherPageAreasInfo().footerPageArea;
            if (pageArea && pageArea.subDocument != activeSubDocument)
                return this.control.commandManager.getCommand(client_command_1.RichEditClientCommand.ChangeActiveSubDocumentToHeaderFooterByPageIndex)
                    .execute(this.control.commandManager.isPublicApiCall, new change_active_sub_document_command_1.ChangeActiveSubDocumentToHeaderFooterByPageIndexCommandParameters(this.control, pageIndex, isHeader));
        }
        return false;
    };
    return GoToNextPrevHeaderFooterCommandBase;
}(header_footer_command_base_1.HeaderFooterCommandBase));
exports.GoToNextPrevHeaderFooterCommandBase = GoToNextPrevHeaderFooterCommandBase;
var GoToNextHeaderFooterCommand = (function (_super) {
    tslib_1.__extends(GoToNextHeaderFooterCommand, _super);
    function GoToNextHeaderFooterCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoToNextHeaderFooterCommand.prototype.moveFunction = function (pageIndex) {
        return ++pageIndex;
    };
    return GoToNextHeaderFooterCommand;
}(GoToNextPrevHeaderFooterCommandBase));
exports.GoToNextHeaderFooterCommand = GoToNextHeaderFooterCommand;
var GoToPreviousHeaderFooterCommand = (function (_super) {
    tslib_1.__extends(GoToPreviousHeaderFooterCommand, _super);
    function GoToPreviousHeaderFooterCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoToPreviousHeaderFooterCommand.prototype.moveFunction = function (pageIndex) {
        return --pageIndex;
    };
    return GoToPreviousHeaderFooterCommand;
}(GoToNextPrevHeaderFooterCommandBase));
exports.GoToPreviousHeaderFooterCommand = GoToPreviousHeaderFooterCommand;
